<template lang="pug">
.queue-card
  .bg
    img(src="~assets/queue-5g.png")
  .content
    .title DAMO 5G赛车漂移
    queue-info(:exhibitId="exhibitId")

</template>
<script>
import QueueInfo from '@/components/home/QueueInfo'
export default {
  name: 'QueueCard2',
  components: { QueueInfo },
  props: {
    code: {},
    exhibitId: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onQueue() {},
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.queue-card
  width: pxToRem(750)
  height: pxToRem(332)
  position: relative
  .bg
    +full
    img
      width: 100%
      height: 100%
      object-fit: contain
      display: block
  .content
    position: absolute
    padding: pxToRem(60)
    .title
      font-size: pxToRem(36)
      line-height: pxToRem(38)
      color: white
      text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
    .subtitle
      color: white
      margin-top: pxToRem(10)
      font-size: pxToRem(24)
      text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
    .queue-btn
      margin-top: pxToRem(30)
      margin-bottom: pxToRem(10)
      width: pxToRem(168)
      height: pxToRem(58)
      border-radius: pxToRem(29)
      background: white
      color: #1664FF
      font-size: pxToRem(30)
      line-height: pxToRem(58)
      text-align: center
    .queue-code
      font-size: pxToRem(60)
      color: white
    .warning
      display: flex
      align-items: center
      flex-direction: row
      position: absolute
      img
        width: pxToRem(31)
        height: pxToRem(31)
        object-fit: contain
        margin-right: pxToRem(10)
        margin-bottom: pxToRem(-4)
      span
        font-size: pxToRem(24)
        color: white
        border-bottom: white 1px solid
</style>
